import React, { useState } from "react";
import StaffBWTS from "./CargoMachineryFields/BwtsDetails";
import StaffIGG from "./CargoMachineryFields/IggDetails";
import StaffCargoCrane from "./CargoMachineryFields/CraneCorgo";
import StaffLPGCargoCompressor from "./CargoMachineryFields/LpgCargoCompressor";
import StaffLNGCargoCompressor from "./CargoMachineryFields/LngCargoCompressor";
import StaffNitrogenPlant from "./CargoMachineryFields/NitrogenPlant";
import StaffCopt from "./CargoMachineryFields/Copt";
import StaffFramo from "./CargoMachineryFields/Framo";

function SubTabCargoMachinary({ id }) {
  const [activeTab, setActiveTab] = useState("BWTS");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li className={activeTab === "BWTS" ? "active" : ""} onClick={() => handleClick("BWTS")}>
            BWTS
          </li>
          <li className={activeTab === "IGG" ? "active" : ""} onClick={() => handleClick("IGG")}>
            IGG
          </li>

          <li
            className={activeTab === "CargoCrane" ? "active" : ""}
            onClick={() => handleClick("CargoCrane")}
          >
            Cargo Crane
          </li>
          <li
            className={activeTab === "LpgCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LpgCargoCompressor")}
          >
            LPG Cargo Compressor
          </li>
          <li
            className={activeTab === "LngCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LngCargoCompressor")}
          >
            LNG Cargo Compressor
          </li>
          <li
            className={activeTab === "NitrogenPlant" ? "active" : ""}
            onClick={() => handleClick("NitrogenPlant")}
          >
            Nitrogen Plant
          </li>

          <li className={activeTab === "Copt" ? "active" : ""} onClick={() => handleClick("Copt")}>
            Copt
          </li>
          <li
            className={activeTab === "Framo" ? "active" : ""}
            onClick={() => handleClick("Framo")}
          >
            Framo
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "BWTS" && <StaffBWTS id={id} />}
        {activeTab == "IGG" && <StaffIGG id={id} />}
        {activeTab == "CargoCrane" && <StaffCargoCrane id={id} />}
        {activeTab == "LpgCargoCompressor" && <StaffLPGCargoCompressor id={id} />}
        {activeTab == "LngCargoCompressor" && <StaffLNGCargoCompressor id={id} />}
        {activeTab == "NitrogenPlant" && <StaffNitrogenPlant id={id} />}
        {activeTab == "Copt" && <StaffCopt id={id} />}
        {activeTab == "Framo" && <StaffFramo id={id} />}
      </div>
    </>
  );
}

export default SubTabCargoMachinary;
